
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/afiliado/[slug]",
      function () {
        return require("private-next-pages/afiliado/[slug].tsx");
      }
    ]);
  